import React from 'react';

import Button from '@atlaskit/button/new';

export default function ButtonDangerExample(): React.JSX.Element {
	return <Button appearance="danger">Danger button</Button>;
}
